import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROUTING_ESTADO_TRAMITE_PENSION } from '@constants/url.constant';
import { CertificadoOfertasComponent } from './pages/certificado-ofertas/certificado-ofertas.component';
import { CertificadoSaldosComponent } from './pages/certificado-saldos/certificado-saldos.component';
import { EstadoTramitePensionHomeComponent } from './pages/estado-tramite-pension-home/estado-tramite-pension-home.component';
import { InicioTramitePensionComponent } from './pages/inicio-tramite-pension/inicio-tramite-pension.component';
import { ModalidadPensionComponent } from './pages/modalidad-pension/modalidad-pension.component';
import { PagoPensionComponent } from './pages/pago-pension/pago-pension.component';

const routes: Routes = [
  {
      path: "",
      redirectTo: ROUTING_ESTADO_TRAMITE_PENSION.ESTADO_TRAMITE_PENSION_HOME,
      pathMatch: "full",
  },
  {
      path: ROUTING_ESTADO_TRAMITE_PENSION.ESTADO_TRAMITE_PENSION_HOME,
      component: EstadoTramitePensionHomeComponent,
      runGuardsAndResolvers: 'always',
      children: [
      {
        path: ROUTING_ESTADO_TRAMITE_PENSION.INICIO,
        component: InicioTramitePensionComponent,
      },
      {
        path: ROUTING_ESTADO_TRAMITE_PENSION.CERTIFICADOS_SALDOS,
        component: CertificadoSaldosComponent,
      },
      {
        path: ROUTING_ESTADO_TRAMITE_PENSION.CERTIFICADOS_OFERTAS,
        component: CertificadoOfertasComponent,
      },
      {
        path: ROUTING_ESTADO_TRAMITE_PENSION.MODALIDAD_PENSION,
        component: ModalidadPensionComponent,
      },
      {
        path: ROUTING_ESTADO_TRAMITE_PENSION.PAGO_PENSION,
        component: PagoPensionComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EstadoTramitePensionRoutingModule { }